type Observer = (text: string, options?: { focus?: boolean }) => void

const observers = new Set<Observer>()

// 마지막 notify 값. 늦게 register하는 observer가 현재 검색어를 놓치지 않도록 replay에 사용한다.
let lastParams: Parameters<Observer> | null = null

const register = (observer: Observer, options?: { replay?: boolean }) => {
  observers.add(observer)

  // replay를 요청한 observer는 등록 즉시 마지막 notify 값을 전달받는다.
  // 검색 후 뒤늦게 mount되는 provider(linked 리스트 등)가 검색어를 받아 하이라이트를 계산할 수 있게 한다.
  if (options?.replay === true && lastParams != null) {
    observer(...lastParams)
  }

  return () => observers.delete(observer)
}

const notify = (...params: Parameters<Observer>) => {
  lastParams = params
  observers.forEach((observer) => observer(...params))
}

const findTextObserver = {
  register,
  notify,
}

export default findTextObserver
